var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',{staticClass:"mt-5 font-weight-bold"},[_vm._v(_vm._s(_vm.$t("components"))+" "+_vm._s(_vm.base)+":")]),_c('ul',_vm._l((_vm.components),function(item){return _c('li',{key:item.id},[_c('router-link',{attrs:{"to":'/' + item.urlcomponent}},[_vm._v(" "+_vm._s(item.name)+" - "+_vm._s(item.description)+" ")])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }